import React from 'react';

import { HelpCircleIcon } from '@metarouter-private/mr-mui';

import WithTooltip from 'app/components/WithTooltip';

const TOOLTIP_MESSAGE =
  'Advanced Search only searches the events currently loaded below — it does not fetch more. ' +
  'To search for additional data, load more events or adjust the filters above.';

export default function EventDebuggerAdvancedSearchTooltip() {
  return (
    <WithTooltip show title={TOOLTIP_MESSAGE} dataTestId="advancedSearchTooltip">
      <HelpCircleIcon fontSize="small" color="secondary" />
    </WithTooltip>
  );
}
